export default __webpack_public_path__ + "35985884b96288b6723bfc8a8054face.png";